import Swiper from 'swiper'
import { Pagination, Autoplay, EffectFade } from 'swiper/modules'

// SwiperのCSS
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/autoplay'

window.addEventListener('load', function () {
  const mainElement = document.querySelector('body')
  if (mainElement && mainElement.classList.contains('lp_region')) {
    new Swiper('.kv_slider', {
      modules: [Pagination, Autoplay, EffectFade],
      autoplay: {
        delay: 3000,
      },
      loop: true,
      effect: 'fade',
      speed: 1000,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  }
})
